<template>
  <div class="bpm-container">
    <div id="bpm-ins" class="bpm-visual" />
    <Control v-if="lf" class="bpm-control" :lf="lf" @catData="catData"></Control>
    <save-bz :visible.sync="save" :nodeitem="nodeitem" @save="handleNodeSave" @cancel="handleNodeCancel" :lf="lf" />
  </div>
</template>

<script>
import LogicFlow from '@logicflow/core'
import * as registerNode from './components/registerNode'
import Control from './components/registerNode/Control.vue'

// import { Snapshot } from '@logicflow/extension';
import saveBz from './saveBz'
export default {
  name: 'BpmVisual',
  components: { Control, saveBz },
  props: {
    type: {
      type: String,
      default: 'add',
    },
    info: {
      type: Object,
      default: function () {
        return {}
      },
    },
    handelBpmData: {
      type: Function,
    },
  },
  data() {
    return {
      lf: null,
      config: {
        background: {
          color: '#f7f9ff',
        },
        grid: {
          type: 'mesh',
          size: 10,
          visible: true,
          config: {
            color: '#ababab80', // 网格颜色
            // thickness: 10, // 网格线宽度
          },
        },
        keyboard: {
          enabled: true,
        },
        style: {
          rect: {
            radius: 6,
          },
          edgeText: {
            // 边文本样式
            background: {
              fill: '#fff',
            },
          },
        },
        edgeTextDraggable: true,
        guards: {
          beforeClone() {
            // 是否允许拷贝
            return false
          },
          beforeDelete(data) {
            // 可以根据 data 数据判断是否允许删除，允许返回 true,不允许返回 false
            return true
          },
        },
      },
      checkedNode: [],
      save: false,
      /** 当前编辑 Node */
      nodeitem: {},
      /** 画布默认的开始结束节点 */
      initData: {
        nodes: [
          { id: '1', type: 'Start', x: 80, y: 130, properties: {} },
          { id: '4', type: 'End', x: 1010, y: 130, properties: {} },
        ],
      },
      useTheTpl: [],
      flag: true,
    }
  },
  mounted: function () {
    this.$el.style.height = this.$el.clientHeight + 'px'

    // 导出包含有 HTML 元素有问题
    // LogicFlow.use(Snapshot);
    this.getNodesInfo()
    const lf = new LogicFlow({
      ...this.config,
      container: document.querySelector('#bpm-ins'),
    })
    this.lf = lf

    lf.setTheme({
      circle: {
        r: 20,
        stroke: '#000000',
        outlineColor: '#88f',
        strokeWidth: 1,
      },
    })

    registerNode.registerStart(lf)
    registerNode.registerEnd(lf)
    registerNode.registerEngNode(lf, {
      checkedNode: this.checkedNode,
      onChecked: (e, properties) => {
        if (this.checkedNode.indexOf(properties.node.id) > -1) {
          //
        }
      },
    })

    if (this.type === 'edit') {
      this.initData = JSON.parse2JSON(this.info.tplDragNode)
      this.checkUseTpl(() => {
        this.lfrenderEvent()
      })
    } else {
      this.lfrenderEvent()
    }
    lf.render(this.initData)
  },

  methods: {
    checkUseTpl(cb) {
      this.info.bpmId &&
        this.api
          .queryList(
            'YW_SERVICE_ORDER_V1',
            {
              p2: { 'TEMPLATE_ID:0': this.info.bpmId },
              p9: 'SERVICE_ORDER_NUM,WORK_ORDER_NUM,TEMPLATE_ID,TEMPLATE_NODEID',
            },
            'getSerOrderUseTheTpl'
          )
          .then((res) => {
            let rd = res.result || []
            this.useTheTpl = rd
            cb && cb()
          })
    },
    // 节点点击事件
    lfrenderEvent() {
      this.lf.on('node:click', (data) => {
        let properties = data.data.properties
        if (['add', 'edit'].indexOf(this.type) > -1) {
          let params = properties.node
          this.nodeitem = Object.assign(data.data, {
            gNode: this.nodesInfo[params.id] || {},
            // 需要备份的字段
            origin: { bz: params.bz, fileId: params.fileId, imgId: params.imgId },
          })
          this.save = true
        }
      })
      this.lf.on('connection:not-allowed', (data) => {
        this.layer.openMsg(data.msg, { targetEl: $('.bpm-bd') })
      })
      if (this.useTheTpl.length <= 0) {
        // 工单未开始使用，即可删除
        this.lf.on('node:contextmenu', (data) => {
          let _properties = data.data.properties
          if (_properties.children && _properties.children.length) {
            this.layer.openConfirm('请先删除下级节点!', undefined, undefined, {
              targetEl: $('.bpm-bd'),
            })
          } else {
            this.layer.openConfirm(
              '确定要删除这个节点吗?',
              () => {
                this.lf.deleteNode(data.data.id)
                this.handelBpmData()
              },
              null,
              { targetEl: $('.bpm-bd') }
            )
          }
        })

        this.lf.on('edge:contextmenu', (data) => {
          this.layer.openConfirm(
            '确定要删除这条连线吗?',
            () => {
              this.lf.deleteEdge(data.data.id)
            },
            null,
            { targetEl: $('.bpm-bd') }
          )
        })
      } else {
        let str = []
        this.useTheTpl.map((item) => {
          str.push(item.SERVICE_ORDER_NUM)
        })
        this.layer.openConfirm(`服务单【${str.join('、')}】正在使用，不允许修改流程！`, undefined, undefined, {
          targetEl: $('.bpm-bd'),
        })
      }
    },
    /**
     * 获取所有 node 信息
     */
    getNodesInfo: function () {
      this.api.queryList('YW_FLOW_NODE', { p2: {}, p9: '' }, 'bpmGetNodeInfo').then((response) => {
        var result = response.result

        let nodes = {}
        if (result.length > 0) {
          result.map((node) => {
            nodes[node.NODE_ID] = node
          })

          this.nodesInfo = nodes
        }
      })
    },
    // 查看数据
    catData() {
      let graphData = this.lf.getGraphData()
      this.graphData = graphData
    },
    /** 节点编辑：保存 */
    handleNodeSave: function () {
      this.save = false
      let nodeitem = this.nodeitem
      delete nodeitem.gNode
      delete nodeitem.origin
    },
    /** 节点编辑：取消 */
    handleNodeCancel: function (e) {
      this.save = false
      let nodeitem = this.nodeitem
      let origin = nodeitem.origin
      // 恢复之前备份的字段值
      Object.assign(nodeitem, origin)
      delete nodeitem.gNode
      delete nodeitem.origin
      this.nodeitem = {}
    },
  },
}
</script>

<style>
.bpm-container {
  position: relative;
}
.bpm-control {
  position: absolute;
  top: 10px;
  right: 10px;
}
.bpm-visual {
  width: 100%;
  height: 100%;
}
.bpm-visual g[cus-flag='cusEngNode'] foreignObject {
  overflow: visible;
}
.bpm-visual g[cus-flag='cusEngNode'] .lf-element-text {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/workOrder/newBpm/visual.vue